const MFA_DISABLED = 'disabled';
const MFA_RESET = 'reset';
export const GOOGLE_AUTH_KIND = 'google_oauth';
export const GITHUB_AUTH_KIND = 'github_oauth';
export const VERCEL_MARKETPLACE_AUTH_KIND = 'vercel_marketplace_oauth';
export type OAuthProviderKind = typeof GOOGLE_AUTH_KIND | typeof GITHUB_AUTH_KIND | typeof VERCEL_MARKETPLACE_AUTH_KIND;
const PROFILE_NAME_MAX_LENGTH = 256;

export { MFA_DISABLED, MFA_RESET, PROFILE_NAME_MAX_LENGTH };
